(function () {
    'use strict';

    /**
     * @ngdoc object
     *
     *
     * @description
     *
     */
    angular
        .module('dutySheet')
        .controller('JourneyLogCtrl', JourneyLogCtrl);

    function JourneyLogCtrl($uibModalInstance, modalParams, MessageService, EventManagerService,RemoteService,PopupManager,
    		CommonMasterData,ManageFlightService,FlightWatch,TabService,StorageServices,DutySheetService,ApplicationService, CommonLogicService, applicationConstants) {
        var vm = this;
        vm.model = {
        	journeyDetails: modalParams.journeyDetails,
        	joiningCrewCollection: modalParams.joiningCrewCollection,
        	selectedBlock :modalParams.selectedBlock,
        	selectedLeg :[],
          selectedFlightNos:[],
	        masterList : {
				aircraftTypes : [],
				airportList : [],
				fuelSuppliers :[],
				delayCodeDetails :[],
				crewTypeList : [],
				carrierCodes : []

			},
			showNewGD : false,
            clickedOnUpdateFlight : false,
			printSeparateGDForCrewTypes : false,
          carrierCode : null
        };

        vm.popUpDetails = {};
        vm.popUpDetails.airCraftDetails = '';
        vm.popUpDetails.relatedAirCraft = '';
        vm.popUpDetails.approachTypes = '';

        vm.onCloseClick = function () {
          if(vm.model.clickedOnUpdateFlight){
            $uibModalInstance.close('CLOSE');
          } else {
            $uibModalInstance.close();
          }
        };

        vm.assignTraining = function (training, assignFlag) {
            RenewalsService.assignTraining(training, vm.model.selectedCrew, assignFlag);
        };

        vm.updateCheckedBy = function(){
        	var blockId = vm.model.selectedBlock.dutyBlockDetails[0].blockId;
        	var version = vm.model.selectedBlock.dutyBlockDetails[0].version;
        	if(!!blockId && !!version){
        		DutySheetService.updateCheckedBy(blockId,version,
                        function (response) {
                            if(response.success){
                            	vm.model.selectedBlock.dutyBlockDetails[0].version = response.blockDTO.version;
                        		reSearch();
                        		MessageService.success("Checked by updated SuccessFully.");
                            }
                        },
                        function (error) {
                        	reSearch();
                    		MessageService.error(error.msg[0]);
                        }
                    );
        	} else {
        		MessageService.warning("Journy Log does not exsist for the above journey details. So this cannot be Checked.");
            }

        };

        vm.submitJourney = function(){
        	var blockId = vm.model.selectedBlock.dutyBlockDetails[0].blockId;
        	var version = vm.model.selectedBlock.dutyBlockDetails[0].version;
        	if(!!blockId && !!version){
            	DutySheetService.submitJourneyLog(blockId,version,
                        function (response) {
                            if(response.success){
                            	vm.model.selectedBlock.dutyBlockDetails[0].version = response.blockDTO.version;
                        		reSearch();
                        		MessageService.success("Journey log submited SuccessFully.");
                            }
                        },
                        function (error) {
                        	reSearch();
                    		MessageService.error(error.msg[0]);
                        }
                    );
        	}  else {
        		MessageService.warning("Journy Log does not exsist for the above journey details. So this cannot be submitted.");
        	}

        };

        vm.updateFlight = function(){
        	if(vm.model.selectedLeg.length === 0){
        		 MessageService.error("Please select a Flight.");

        	} else {
                vm.model.clickedOnUpdateFlight = true;
        		editFlight(vm.model.selectedLeg);
        	}
        };

        vm.clickOnRow = function(rowdata,legData){
        	if(rowdata.isSelected){
        		vm.model.selectedLeg =[]
        		vm.model.selectedLeg = legData;
            vm.model.selectedFlightNos.push(legData.flightNO);
        	}else {
            var index = vm.model.selectedFlightNos.indexOf(legData.flightNO);
            if(!angular.isUndefined(index))vm.model.selectedFlightNos.splice(index ,1);
          }
        };

        function editFlight(selectedFL){
            var editFlightInfo = ManageFlightService.getFlightInfoForEdit(selectedFL);
            if(editFlightInfo.flightLegId!==null){
                FlightWatch.getAirCraftDetails(editFlightInfo.flightLegId,
                    function (response) {
                        vm.popUpDetails.airCraftDetails = response.flightDetResponceDto;
                        vm.popUpDetails.fuelSuppliers = vm.model.masterList.fuelSuppliers;
                        vm.popUpDetails.airports = vm.model.masterList.airportList;
                        vm.popUpDetails.delayCodeDetails = vm.model.masterList.delayCodeDetails;
                        vm.popUpDetails.updateFlightSource = applicationConstants.UPDATE_FLIGHT_SOURCE.JOURNEY_LOG;
                        FlightWatch.loadAircraftListByCode(editFlightInfo.aircraftModel,
                            function (response) {
                                vm.popUpDetails.relatedAirCraft = response;
                                CommonMasterData.approachTypes(
                                    function (response) {
                                        vm.popUpDetails.approachTypes = response;
                                        PopupManager.openModal('FLIGHT_UPDATE_POPUP', vm.popUpDetails, updateFlightRotationData);
                                    }, function () {}
                                );
                            },
                            function () {
                                console.log('Open Flight search retrieval error');
                            })
                    },
                    function (response) {}
                );
            }
            reSearch();
        };

        function updateFlightRotationData(param) {
            if (param) {

            }
        }

        vm.gdPrint = function() {
            if(vm.model.selectedBlock.isSelected || vm.model.selectedBlock.dutyBlockDetails[0].isSelected){
                var blockId = !!vm.model.selectedBlock.dutyBlockDetails[0] ? vm.model.selectedBlock.dutyBlockDetails[0].blockId : null;
                var crewScheduleEventId = !!vm.model.selectedBlock.dutyBlockDetails[0] ? vm.model.selectedBlock.dutyBlockDetails[0].crewSchEventId : null;
                var selectedCrewTypes = "";

              //set tab data when print separate gd for crew types
				if(vm.model.printSeparateGDForCrewTypes){
					var param = {
				            title: 'Select Required Crew Types To Print In GD',
				            crewTypes : getSelectedCrewTypeObjectList(vm.model.selectedBlock.dutyCrewDetails || vm.model.masterList.crewTypeList)
				        };
						PopupManager.openModal('GD_CREW_TYPE_SELECT_POPUP', param,
								confirmCrewTypeSelection);
				}else{
				  console.log(JSON.stringify(vm.model.selectedBlock.dutyBlockDetails));
          var param = {
            title: 'Select Required Template To Print GD',
            clients : getSelectedGDPrintClientsList(vm.model.selectedBlock.dutyBlockDetails, vm.model.carrierCode)
          };
          PopupManager.openModal('GD_TEMPLATE_SELECT_POPUP', param,
            confirmGDTemplateSelection);
				}
            } else {
            	MessageService.error("Please select duty.");
            }
        };

		//get crew Types as object list
		function getSelectedCrewTypeObjectList(dutyCrewDetails){
			var crewTypes = [], crewTypeObjects = [];
			//set req crew types in the selected duty
			for(var i = 0; i < dutyCrewDetails.length ; i++){
				var crewTypeCode = dutyCrewDetails[i].crewType || dutyCrewDetails[i].crewTypeCode;
				if((crewTypes.indexOf(crewTypeCode) == -1 ) && !!crewTypeCode){
					crewTypes.push(crewTypeCode);
					crewTypeObjects.push({crewTypeCode : crewTypeCode, isSelected :true});
				}
			}
			return crewTypeObjects;
		};

		function confirmCrewTypeSelection(crewTypes) {
			if (!!crewTypes) {
				navigateToGDWindow(vm.model.selectedBlock.dutyBlockDetails[0].blockId, crewTypes,
						vm.model.selectedBlock.dutyBlockDetails[0].crewSchEventId, null);
			}
		};

      function getSelectedGDPrintClientsList(dutyBlockdetails, carrierCode){
        var clients = [],  clientsObjects = [];
        clientsObjects.push({clientCode : carrierCode, isSelected : true});
        clients.push(carrierCode);
        if (dutyBlockdetails[0].flightHubs.length === 0 || dutyBlockdetails[0].flightHubs[0] === null) {

          for (var j = 0; j < vm.model.masterList.carrierCodes.length; j++) {
            var clientCode = vm.model.masterList.carrierCodes[j];
            if (clients.indexOf(clientCode) == -1) {
                      clientsObjects.push({clientCode : clientCode, isSelected : false});
            }
          }
          return clientsObjects;
        }
        for(var i = 0; i < dutyBlockdetails.length ; i++){
          for (var j = 0; j < dutyBlockdetails[i].flightHubs.length; j++) {
            var clientCode = dutyBlockdetails[i].flightHubs[j];
            if (clients.indexOf(clientCode) == -1) {
              clientsObjects.push({clientCode : clientCode, isSelected : false});
              clients.push(clientCode);
            }
          }
        }
        return clientsObjects;
      };

      function confirmGDTemplateSelection(clients) {
        if (!!clients) {
          navigateToGDWindow(vm.model.selectedBlock.dutyBlockDetails[0].blockId, null, vm.model.selectedBlock.dutyBlockDetails[0].crewSchEventId, clients);
        }
      };


      function navigateToGDWindow(blockId, crewTypes , crewScheduleEventId, clients){
			var tabData = { blockId : blockId, crewScheduleEventId : crewScheduleEventId};
			var selectedCrewTypes = getSelectedCrewTypes(crewTypes);
			if(!!selectedCrewTypes && selectedCrewTypes !== ""){
				tabData.crewTypes = selectedCrewTypes;
			}

        var selectedTemplate = getSelectedGDTemplate(clients);
        //print gd
			if(!vm.model.showNewGD){
				var tabName = 'printGD';
				StorageServices.setTabData(tabName, 'printGDParams', tabData);
				TabService.gotoTab(tabName, tabData, 'popup');
			}else{
				redirectToNewGDReport(blockId, selectedCrewTypes, crewScheduleEventId, selectedTemplate);
			}
		};

      function getSelectedGDTemplate(clients){
        if(!!clients){
          for(var i=0; i < clients.length; i++){
            if(clients[i].isSelected){
              return clients[i].clientCode;
            }
          }
        }
        return null;
      };

		//get selected crew type as comma separated string
		function getSelectedCrewTypes(crewTypes){
			var selectedCrewTypes = [];
			var crewTypesStr = null;
			if(!!crewTypes){
				for(var i=0; i < crewTypes.length; i++){
					if(crewTypes[i].isSelected){
						selectedCrewTypes.push(crewTypes[i].crewTypeCode);
					}
				}
				crewTypesStr = selectedCrewTypes.join(',');
			}
			return crewTypesStr;
		};

		// load new GD
		function redirectToNewGDReport(blockId, crewTypes, crewScheduleEventId, client) {
		  var flightNumbers = vm.model.selectedFlightNos.length > 0
		      ? vm.model.selectedFlightNos.map(function(fn) {
		            return (fn.indexOf('(') !== -1 && fn.charAt(fn.length - 1) === ')')
		                ? fn.substring(fn.indexOf('(') + 1, fn.length - 1)
		                : fn;
		        }).join(',')
		      : null;
      var rptDesign = client.toLowerCase() + "_gd_report.rptdesign";
      var url = CommonLogicService.getReportUrl(rptDesign, getParamMap(blockId, crewTypes, crewScheduleEventId, flightNumbers), 'Y', 'Y');
			window.open(url);
		}

		//set param map
		function getParamMap(blockId, crewTypes, crewScheduleEventId ,flightNumbers){
			var searchParamMap = {};
			searchParamMap["blockId"] = blockId;
			if(!!crewScheduleEventId){
				searchParamMap["crewScheduleEventId"] = crewScheduleEventId;
			}
			if(!!crewTypes || crewTypes == ""){
				searchParamMap["crewTypes"] = crewTypes;
			}

			if(!!flightNumbers){
				searchParamMap["flightNos"] = flightNumbers;
			}
			searchParamMap["__format"] =  'pdf';
			searchParamMap["__dpi"] =  96;
			searchParamMap["__pageoverflow"] =  1;
			searchParamMap["__overwrite"] =  false;
			return searchParamMap;
		};

        vm.journeyLogPrint = function() {

            var rptDesign = "journey_log.rptdesign";

            var blockId = vm.model.selectedBlock.dutyBlockDetails[0].blockId;
            var crewSchdEventId = vm.model.selectedBlock.dutyBlockDetails[0].crewSchEventId;

            var data = {
                blockId : blockId,
                crewSchdEventId :angular.isUndefined(crewSchdEventId)?null:crewSchdEventId,
                referrer : window.location.origin,
                __format : 'pdf',
                __dpi : 96,
                __pageoverflow : 1,
                __overwrite : false
            };

            var url = CommonLogicService.getReportUrl(rptDesign,data ,'Y', 'Y');

            window.open(url);

        };

         function reSearch(){
        	 var params = DutySheetService.getJourneyLogRq(vm.model.selectedBlock);
        	 DutySheetService.getJourneyLogData(params,
                     function (response) {
                         if(response.success){
                             var details = {};
                             if(!!response.block && !!response.block.blockId){
                            	 	if(!!vm.model.selectedBlock.dutyBlockDetails && vm.model.selectedBlock.dutyBlockDetails.length > 0){
                            	 		vm.model.selectedBlock.dutyBlockDetails[0].blockId = response.block.blockId;
                                	 	vm.model.selectedBlock.dutyBlockDetails[0].version = response.block.version;
                            	 	}
								}
                             vm.model.journeyDetails = response.journeyDetails;
                             vm.model.joiningCrewCollection = response.joiningCrewCollection;
                         }
                     },
                     function (error) {
                         MessageService.error(error);
                     }
                 );
         }


      (function() {

			CommonMasterData.getAircraftTypeList(function(aircrafts) {
				vm.model.masterList.aircraftTypes = aircrafts;
			}, function() {
				console.log('Aircraft types retrieval error');
			});

			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function() {
				console.log('Airport List retrieval error');
			});

			CommonMasterData.getDelayCodeDetails(function (response) {
                vm.model.masterList.delayCodeDetails = response.delayCodeAdaptDTOs;
            }, function () {});
			//get showing new gd flag
			CommonMasterData.getShowNewGD(function(flag) {
				vm.model.showNewGD = flag;
			}, function(error) {
				console.log('GD Showing Flag retrieval error');
			});
			//print separate gd for crew type flag
			CommonMasterData.getPrintSeparateGDForCrewTypes(function(flag) {
				vm.model.printSeparateGDForCrewTypes = flag;
			}, function(error) {
				console.log('Print Seperate GD For Crew Types Flag retrieval error');
			});
			// crew type codes
			CommonMasterData.getCrewTypeList(function(crewTypeList) {
				vm.model.masterList.crewTypeList = crewTypeList;
			}, function() {
				console.log('Crew Type Code list retrieval error');
			});
			// carrier codes
			CommonMasterData.getPrintGdHubs(function(hubs) {
				vm.model.masterList.carrierCodes = hubs.hubCodes;
			}, function() {
				console.log('Carrier Code list retrieval error');
			});

        CommonMasterData.getCarrierCode(function (code) {
          vm.model.carrierCode = code;
        }, function() {
          console.log('carrier code retrieval error');

        });



		})();


    }
}());
